export default function iframeHeightSetter(selector, ratio = 9 / 16) {
    const embedElements = document.querySelectorAll(selector);
    const setHeight = function (embeds) {
        embeds.forEach(embed => {
            if (embed instanceof HTMLIFrameElement) {
                embed.style.height = embed.scrollWidth * ratio + 'px'
            }
        })
    }
    setHeight(embedElements);
    window.addEventListener('resize', () => {
        setHeight(embedElements);
    })
}